import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type ToastType =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "loading"
  | "default";

export const ToastNotifier = (
  message: string,
  type: ToastType = "default",
  options?: ToastOptions
) => {
  switch (type) {
    case "success":
      toast.success(message, options);
      break;
    case "warning":
      toast.warning(message, options);
      break;
    case "error":
      toast.error(message, options);
      break;
    case "info":
      toast.info(message, options);
      break;
    case "loading":
      toast.loading(message, options);
      break;
    default:
      toast.info(message, options);
      break;
  }
};
